import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";
import { field } from "@/components/admin/SettingsPanel";

const KEYS = ["kind", "url", "department", "title_en", "title_mh", "album", "date"];

export const GalleryForm = ({ item, albums, deps = [], onClose, onSaved }) => {
  const [f, setF] = useState(item);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put(`/gallery/${item.id}`, Object.fromEntries(KEYS.map((k) => [k, f[k] ?? ""])));
      onSaved(!!data?.pending);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };
  const input = (k, label, extra = {}) => (
    <label className="block">
      <span className="mb-1.5 block font-ui text-[11px] uppercase tracking-widest text-[#B7BFCC]">{label}</span>
      <input data-testid={`gallery-form-${k}`} value={f[k] || ""} onChange={set(k)} className={field} {...extra} />
    </label>
  );
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="gallery-form-dialog" className="max-w-lg border-[#D4AF37]/20 bg-[#131C2E] text-[#F4EEE2]">
        <DialogHeader><DialogTitle className="font-display text-3xl">Edit {item.kind}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="grid gap-4">
          <label className="block">
            <span className="mb-1.5 block font-ui text-[11px] uppercase tracking-widest text-[#B7BFCC]">Department</span>
            <select data-testid="gallery-form-department" value={f.department || ""} onChange={set("department")} className={field}>
              <option value="">No department</option>
              {deps.map((d) => <option key={d.slug} value={d.slug}>{d.en}</option>)}
            </select>
          </label>
          {input("title_en", "Caption (English)")}
          {input("title_mh", "Caption (Marshallese)")}
          {input("album", "Album / program / event", { list: "gallery-form-albums" })}
          <datalist id="gallery-form-albums">{albums.map((a) => <option key={a} value={a} />)}</datalist>
          {input("date", "Date", { type: "date" })}
          <button data-testid="gallery-form-save-btn" disabled={busy} className="flex items-center justify-center gap-2 rounded-full bg-[#D4AF37] py-3 font-ui font-semibold text-[#0B111E] disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Save
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
